import Croppie, { CropType } from 'croppie';
import { Dispatch } from 'redux';

import { selectProfilePicture } from './profile-picture.actions';

export const getBase64 = (file: Blob) => {
    return new Promise(resolve => {
        let baseURL: string | ArrayBuffer | null;

        const reader = new FileReader();

        // Convert the file to base64 text
        reader.readAsDataURL(file);

        reader.onload = () => {
            baseURL = reader.result;
            resolve(baseURL);
        };
    });
};

export const getCroppedImage = async (selectedFile: Blob, dispatch: Dispatch) => {
    let c: Croppie | null = null;

    await getBase64(selectedFile).then(result => {
        let croppie: HTMLDivElement | null = null;

        if (document.getElementById('profile-image')) {
            croppie = document.getElementById('profile-image') as HTMLDivElement;
        }
        const croppieOptions = {
            showZoomer: true,
            enableOrientation: true,
            enforceBoundary: true,
            viewport: {
                width: 100,
                height: 100,
                type: 'circle' as CropType
            },
            boundary: {
                width: 235,
                height: 235
            }
        };

        if (croppie) {
            c = new Croppie(croppie,
                croppieOptions
            );
            dispatch(selectProfilePicture(result as string));
            c.bind({ url: result as string });
        }
    });

    return c;
};

export const dragOverHandler = (e: DragEvent) => {
    e.preventDefault();
};

export const onDropHandle = (e: DragEvent, dispatch: Dispatch) => {
    e.preventDefault();
    const selectedFile = e.dataTransfer?.items[0].getAsFile() as Blob;

    return getCroppedImage(selectedFile, dispatch);
};

export const isValidImageType = (type: string | undefined) => {
    if(!type) return false;

    return ['image/jpeg', 'image/jpg', 'image/gif', 'image/png'].indexOf(type) > -1;
};
